import React, { useContext, useMemo, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import LightBox from 'react-image-lightbox';
import { StoryPageContext, usePageMedia } from '../StoryPage';
import useEntities from '../hooks/useEntities';

const useLightboxImages = pageId => {
  const allImages = useEntities('images');
  const allTexts = useEntities('texts');
  const pageMedia = usePageMedia(pageId);

  const pageImages = useMemo(() => {
    return pageMedia
      .filter(medium => medium.type === 'images')
      .map(image => ({
        id: image.id,
        src: allImages[image.id]['image-versions'][3].url,
        srcThumbnail: allImages[image.id]['image-versions'][8].url,
        caption: (image.captionTextId && allTexts[image.captionTextId].text) || '',
      }));
  }, []);

  return pageImages;
};

const Lightbox = ({ pageId }) => {
  const { lightboxMedia, setLightboxMedia } = useContext(StoryPageContext);
  const images = useLightboxImages(pageId);
  const [index, setIndex] = useState(null);

  useEffect(() => {
    if (lightboxMedia !== null) {
      const initialImageIndex = images.map(img => img.id).indexOf(lightboxMedia);
      setIndex(initialImageIndex);
    }
  }, [lightboxMedia]);

  if (!lightboxMedia || index === null) return false;

  return (
    <LightBox
      mainSrc={images[index].src}
      srcThumbnail={images[index].srcThumbnail}
      imageCaption={images[index].caption}
      nextSrc={images[(index + 1) % images.length].src}
      prevSrc={images[(index + images.length - 1) % images.length].src}
      nextSrcThumbnail={images[(index + 1) % images.length].srcThumbnail}
      prevSrcThumbnail={images[(index + images.length - 1) % images.length].srcThumbnail}
      onMovePrevRequest={() => setIndex((index + images.length - 1) % images.length)}
      onMoveNextRequest={() => setIndex((index + 1) % images.length)}
      onCloseRequest={() => setLightboxMedia(null)}
    />
  );
};

Lightbox.propTypes = {
  pageId: PropTypes.string.isRequired,
};

export default Lightbox;
